import React from 'react';

import routes from '@/services/routes';

import styles from './GooglePrivacyBlurb.module.css';

function GooglePrivacyBlurb() {
    return (
        <div className="mt-0">
            <p className={styles.content}>
                Sixty AI&apos;s use and transfer of information received from Google APIs
                adheres to the
                {' '}
                <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://developers.google.com/terms/api-services-user-data-policy#additional_requirements_for_specific_api_scopes"
                    className={styles.smallLink}
                >
                    Google API Services User Data Policy
                </a>
                , including the Limited Use requirements. See our
                {' '}
                <a
                    target="_blank"
                    rel="noreferrer"
                    href={routes.PRIVACY_POLICY}
                    className={styles.smallLink}
                >
                    Privacy Statement
                </a>
                {' '}
                for more information.
            </p>
        </div>
    );
}

export default GooglePrivacyBlurb;
